let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iLfpK")).then(() => parcelRequire('fYdPe'));